<mat-form-field
  class="form-chip-list"
  data-cy="speciality-input">
  <mat-label>{{
    ("careSector" | i18n) || "Erfahrung / Pflegebereich" | titlecase
  }}</mat-label>
  <mat-chip-list
    #specialityList
    [disabled]="disabled$ | async">
    <mat-chip
      *ngFor="
        let speciality of _selectedSpecialities$ | async;
        trackBy: trackBySpecialityId
      "
      [attr.data-cy]="'selected-speciality-' + speciality._id"
      [attr.title]="speciality.name"
      class="speciality-chip">
      <span>{{ speciality.name }}</span>
      <mat-icon
        matChipRemove
        *ngIf="!(disabled$ | async)"
        data-cy="remove-speciality"
        svgIcon="close-circle"
        (click)="removeSpeciality(speciality._id)">
      </mat-icon>
    </mat-chip>

    <input
      ngModel
      #specialityInput="ngModel"
      name="specialityInput"
      [disabled]="!!(disabled$ | async)"
      [matAutocomplete]="autoSpecialities"
      [matChipInputFor]="specialityList"
      data-cy="speciality-text-input" />
  </mat-chip-list>
  <mat-autocomplete
    #autoSpecialities="matAutocomplete"
    (optionSelected)="selectedSpeciality($event)">
    <mat-option
      *ngFor="
        let speciality of filteredSpecialities$ | async;
        trackBy: trackBySpecialityId
      "
      [attr.data-cy]="'speciality-option-' + speciality._id"
      [value]="speciality">
      {{ speciality.name }}
    </mat-option>
  </mat-autocomplete>
  <mat-hint
    *ngIf="showHint$ | async"
    align="end">
    <ng-content select="[slot=hint]"></ng-content>
  </mat-hint>
</mat-form-field>
